import React from "react";
import styled from "styled-components";
import Link from "../Link";

const StyledLogo = styled(Link)`
  transition: fill 150ms ease-in-out, opacity 150ms ease-in-out;

  path {
    fill: ${props => props.theme.colors.text};
  }

  &:hover {
    path {
      fill: ${props => props.theme.colors.secondary};
    }
  }
`;

const Logo = () => (
  <StyledLogo to="/">
    <svg
      width="64"
      height="62"
      viewBox="0 0 64 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 14.1H46.9C47.5 14.1 47.9 13.7 47.9 13.1C47.9 12.5 47.5 12.1 46.9 12.1H46C45.4 12.1 45 12.5 45 13.1C45 13.7 45.5 14.1 46 14.1Z"
        fill="#4D3AE2"
      />
      <path
        d="M62.9 14.4L60.8 13.5L62.9 12.6C63.4 12.4 63.6 11.8 63.4 11.3C63.2 10.8 62.6 10.6 62.1 10.8L58.3 12.4L30.4 0.399988C30.2 0.299988 30 0.299988 29.9 0.299988C22.9 0.699988 16 3.09999 10 6.99999C9.6 7.29999 9.4 7.89999 9.7 8.29999L11.1 10.6C6.4 13.9 2.1 17.6 0.600002 24C0.500002 24.5 0.800002 25 1.3 25.2L2.5 25.6C0.800002 29.9 0.100002 34.5 0.600002 39.1C0.700002 39.6 1.1 40 1.6 40C1.6 40 1.6 40 1.7 40L2.7 39.9C2.7 43.7 3.6 47.5 5.4 50.9C5.6 51.2 5.9 51.4 6.3 51.4C6.4 51.4 6.6 51.4 6.7 51.3C8 50.7 9.3 50.1 10.6 49.5L11 49.3C13.4 53.2 17.6 56.8 23.8 60C24.1 60.1 24.4 60.2 24.6 60L26.4 59.3C28.3 60.9 31 61.8 34.1 61.5C34.6 61.4 35 60.9 35 60.4C34.9 59.9 34.4 59.5 33.9 59.5C31.4 59.8 29.7 59.1 28.6 58.4L31 57.4C32.9 59 35.5 59.9 38.6 59.5C39.1 59.4 39.5 58.9 39.5 58.4C39.5 57.9 38.9 57.5 38.4 57.5C36 57.8 34.2 57.1 33.2 56.5L34.4 56C35.3 55.6 35.2 54.3 34.2 54.1C29.5 53.1 24.2 48.9 18.6 44.3C18.2 43.3 17.9 41.4 17.8 39.5L22.3 41.5C22.8 41.7 23.4 41.5 23.6 41C23.8 40.5 23.6 39.9 23.1 39.7L17.7 37.3C17.7 36 18.3 33.9 18.9 31.8L24.4 36.3C24.8 36.6 25.5 36.6 25.8 36.2C26.1 35.8 26.1 35.1 25.7 34.8L19.6 30C20.1 28.9 20.4 28.7 21.1 28.3C21.3 28.2 21.5 28 21.8 27.9L28 33.8C28.4 34.2 29 34.2 29.4 33.8C29.8 33.4 29.8 32.8 29.4 32.4L23.6 26.8C34.6 20.5 45.3 30.6 58.7 14.8L62.2 16.3C62.7 16.5 63.3 16.3 63.5 15.8C63.7 15.2 63.4 14.6 62.9 14.4ZM3.4 37.9L2.5 38C2.2 34 2.9 30 4.4 26.3L17 30.4L17.2 30.6C16.6 32.2 15.8 35.1 15.6 37.1L3.6 37.8C3.5 37.9 3.5 37.9 3.4 37.9ZM9.7 47.8C8.7 48.3 7.7 48.7 6.7 49.2C5.3 46.3 4.6 43.1 4.6 39.8L15.7 39.2C15.8 40.6 16 43 16.5 44.7L9.7 47.8ZM31 55.4L24.3 58.1C18.8 55.1 15 52 12.8 48.5L17.6 46.2C22.2 50.2 26.8 53.7 31 55.4ZM20 26.6C19.2 27.1 18.7 27.5 18 28.7L4.2 24.1L2.9 23.7C4.4 18.5 8 15.5 12.3 12.5L20.7 26.4C20.4 26.4 20.2 26.5 20 26.6ZM29 22.6C26.6 23 24.3 23.9 22.2 25.1L13.3 10.4C13.3 10.3 13.2 10.3 13.2 10.2L11.9 8.09999C17.1 4.89999 23 2.89999 29 2.39999V22.6ZM39.4 22.3C38.4 22.3 33.3 22.4 31.1 22.5V2.79999L40.1 6.69999C39.3 8.89999 38.9 11.2 38.9 13.5C38.9 16.5 39.6 19.5 41 22.2C40.4 22.3 39.9 22.3 39.4 22.3ZM43 22C41.6 19.4 40.8 16.5 40.8 13.6C40.8 11.5 41.2 9.49999 41.9 7.59999L56.7 14C54.8 16 49.9 20.7 43 22Z"
        fill="#4D3AE2"
      />
    </svg>
  </StyledLogo>
);

export default Logo;
